export default __webpack_public_path__ + "static/media/plan.9e14ec53.jpg";